// libs
import { styled } from '@nykaa/ui-components';
import { css } from '@emotion/core';
import { hexToRgb } from '@nykaa/ui-components/styles/utils';

// constants
import {
  BREAKPOINTS,
  COLORS,
  DWEB_MAX_WIDTH,
  HIDE_SCROLLBARS,
  HORIZONTAL_SCROLLBARS,
} from 'shared/styles/base';
import { truncate } from 'shared/styles/mixin';

// components
import Toast from 'shared/ui-components/Toast';
import ViewDetailsNudgeMobile from 'shared/layouts/Coupons/ViewDetailsNudge';
import BaseViewDetailsNudgeMobileOffer from 'shared/layouts/Coupons/ViewDetailsNudge/ViewDetailsOffer';
import BaseViewDetailsNudgeDesktopCoupon from 'shared/layouts/Coupons/ViewDetailsNudge/viewDetailsNudgeDesktopCoupons';

export const ContainerWrapper = styled.div<{ parentOverflow?: boolean; }>`
  ${({ parentOverflow, theme }) =>
    parentOverflow
      ? `
  position: relative;
  margin: 0px -${theme.spacing.spacing80};
  background: ${theme.colors.pdpCouponsSectionBg};
  width: 100vw;`
      : `width: 100%;`};

  .couponContainer {
    width: 60%;
  }

  @media (max-width: ${DWEB_MAX_WIDTH}px) {
    .couponContainer {
      width: 75%;
    }
  }

  @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
     padding-left: ${({ theme }) => theme.spacing.spacing80};
    .couponContainer {
      width: 75%;
      padding-top: ${({ theme }) => theme.spacing.spacing0};
      margin-top: ${({ theme }) => theme.spacing.spacing80};
      ${({ theme }) => `margin-right: ${theme.spacing.spacing40};`};
    }

    .couponContainerFull {
      width: 100%;
      padding-top: ${({ theme }) => theme.spacing.spacing0};
      margin-top: ${({ theme }) => theme.spacing.spacing80};
      margin-right: ${({ theme }) => theme.spacing.spacing80};
    }
  }
`;

export const Container = styled.div`
  max-width: 100%;
  overflow: hidden;
  ${({ theme }) => css`
  margin-top: ${theme.spacing.spacing80};
  ${theme.typography.bodyMedium};
  @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
    padding-top: ${theme.spacing.spacing80};
    margin-top: ${theme.spacing.spacing0};
  } ;
`};
`;

export const CouponsContainer = styled.div<{ hideScroll?: boolean; }>`
  ${({ theme }) => `
      padding: 0 0px ${theme.spacing.spacing60} 0px;
      @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
        padding-bottom: ${theme.spacing.spacing40};
      }
      display: flex;
      width: 100%;
      scroll-snap-stop: always;
      scroll-snap-type: x mandatory; overflow: scroll;`};
  ${({ hideScroll }) => (hideScroll ? HIDE_SCROLLBARS : HORIZONTAL_SCROLLBARS)};
`;

export const CardsContainer = styled.div`
  width: 100%;
  overflow: scroll;
  ${HIDE_SCROLLBARS} @media(max-width: ${BREAKPOINTS.DESKTOP}px) {
    display: flex;
  }
`;

export const Content = styled.div<{
  havePaddingLeft?: boolean;
  hasExtraMargin?: boolean;
  offersAvailable: boolean;
}>`
  width: 100%;
  overflow: hidden;
  ${({ havePaddingLeft, theme }) => havePaddingLeft && `padding-left: ${theme.spacing.spacing80}`};
  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme, hasExtraMargin }) =>
    `margin-bottom: ${hasExtraMargin ? theme.spacing.spacing160 : theme.spacing.spacing60}`};

    ${({ theme, offersAvailable }) =>
    `margin-bottom: ${offersAvailable ? theme.spacing.spacing160 : theme.spacing.spacing0}`};
  }
`;

export const Dot = styled.div`
  ${({ theme }) =>
    css`
      border-radius: ${theme.borders.radius50};
      height: ${theme.spacing.spacing20};
      width: ${theme.spacing.spacing20};
      background-color: ${theme.colors.textSecondary};
    `};
`;

export const TitleContainer = styled.div<{ havePaddingLeft?: boolean; }>`
  display: flex;
  align-items: center;
  ${({ havePaddingLeft, theme }) => havePaddingLeft && `padding-left: ${theme.spacing.spacing80}`};
`;

export const HeaderTitle = styled.h2`
  margin: 0;
  ${({ theme }) => css`
    padding-right: ${theme.spacing.spacing40};
    ${theme.typography.titleSmall};
    color: ${theme.colors.textPrimary};

    @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
      ${theme.typography.titleMedium};
    }
  `};
`;

export const OffersCountText = styled.span`
  ${({ theme }) => css`
    ${theme.typography.bodyMedium};
    padding-left: ${theme.spacing.spacing40};
    color: ${theme.colors.textSecondary};
  `};
`;

export const ActionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  ${({ theme }) => css`
    border-radius: ${theme.borders.radius10};
    /* background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='2' ry='2' stroke='%23d6d9dc' stroke-width='2' stroke-dasharray='3%2c 3' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e"); */
    border-radius: 0 0 ${theme.borders.radius10} ${theme.borders.radius10};
    border-style: dashed;
    border-color: ${theme.colors.textOutline};
  `};
  background-clip: padding-box;
  width: 100%;
`;

export const CouponCodeContainer = styled.div`
  display: flex;
  align-items: center;
  // Button Size 115px
  width: calc(100% - 115px);
`;

export const CouponCode = styled.div`
  ${truncate};
  ${({ theme }) => css`
    ${theme.typography.subTitleMedium};
    margin: ${theme.spacing.spacing50} ${theme.spacing.spacing60};
    color: ${theme.colors.textSecondary};
    @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
      margin: ${theme.spacing.spacing50} ${theme.spacing.spacing80};
    } ;
  `};
`;

export const AppliedText = styled.div<{ disabled: boolean; }>`
  ${({ theme }) => css`
    ${theme.typography.labelSmall}
    padding: ${theme.spacing.spacing10} ${theme.spacing.spacing40};
    background-color: ${COLORS.GREEN};
    color: ${theme.colors.surface};
    margin-right: ${theme.spacing.spacing40};
  `}
`;

export const Button = styled.button<{ disabled: boolean; isApplied: boolean; }>`
  border: 0;
  ${({ theme, disabled, isApplied }) =>
    css`
      ${theme.typography.buttonMedium};
      color: ${theme.colors.secondary};
      ${disabled && `color: ${theme.colors.textDisabled}`};
      ${isApplied &&
      `color: ${theme.colors.textSecondary};
        padding: ${theme.spacing.spacing50} ${theme.spacing.spacing80};
      `};
      padding: ${theme.spacing.spacing50} ${theme.spacing.spacing60};
    `};

  @media screen and (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.buttonLarge}
  }
  align-items: center;
  background: transparent;
  outline: none;
  cursor: pointer;
`;

export const ActionContainerDetails = styled.div`
  ${({ theme }) => `padding: ${theme.spacing.spacing80} ${theme.spacing.spacing100}`};
  display: flex;
  justify-content: space-between;
`;

export const CustomToast = styled(Toast) <{ showTextCenter?: boolean; }>`
  justify-content: center;
  z-index: 10006;
  ${({ theme }) => css`
    padding: ${theme.spacing.spacing80} ${theme.spacing.spacing40};
    background: linear-gradient(0deg, ${hexToRgb(theme.colors.textOutline, 0.16)}, ${hexToRgb(theme.colors.textOutline, 0.16)}),
      linear-gradient(0deg, ${hexToRgb('#FFFFFF', 0.03)}, ${hexToRgb('#FFFFFF', 0.03)}),
      ${theme.colors.primary};
    box-shadow: ${theme.elevations.shadow300};
    border-radius: ${theme.borders.radius10};
    position: fixed;
    bottom: calc(${theme.spacing.spacing480} + ${theme.spacing.spacing40});
    left: ${theme.spacing.spacing40};
    right: ${theme.spacing.spacing40};
    ${theme.typography.bodyMedium};
    max-width: 360px;
    margin: 0 auto;
    color: ${theme.colors.surface};
  `}
`;

export const ViewDetailsNudgeMobileNew = styled(ViewDetailsNudgeMobile)`
  .header {
    border-bottom: 1px solid ${({ theme }) => theme.colors.textOutline};
  }

  .infoContainer {
    padding: ${({ theme }) => `${theme.spacing.spacing80} 0`};
  }

  .iconContainer {
    ${({ theme }) => `margin-right: ${theme.spacing.spacing80}`};
  }

  .termsConditionsList {
    ${({ theme }) => `padding: 0 0 0 ${theme.spacing.spacing60}`};
  }

  .viewMoreButton {
    padding: 0;
  }

  .couponCode {
    letter-spacing: 0.3px;
  }
`;

export const ViewDetailsNudgeMobileOffer = styled(BaseViewDetailsNudgeMobileOffer)`
  .offer-info {
    ${({ theme }) => `padding-bottom: ${theme.spacing.spacing40}`};
  }

  .subtitle {
    padding-bottom: 0;
  }

  .title {
    ${({ theme }) => `padding-bottom: ${theme.spacing.spacing20}`};
  }
`;

export const ViewDetailsNudgeDesktopCoupon = styled(BaseViewDetailsNudgeDesktopCoupon)`
  .termsConditionsList {
    ${({ theme }) => `padding: 0 0 0 ${theme.spacing.spacing60}`};
  }

  .couponCode {
    letter-spacing: 0.3px;
  }

  .infoContainer {
    ${({ theme }) => `margin: 0 ${theme.spacing.spacing160}`};
  }

  .couponCodeContainer {
    ${({ theme }) => `padding: ${theme.spacing.spacing20} ${theme.spacing.spacing160}`};
  }
`;
